import React, { useMemo } from 'react';

import { Color, ColoredChipLight } from '../../../../components/ColoredChip';

const getStatus = (status: string): Color => {
  switch (status) {
    case 'upcoming':
      return 'gray';
    case 'ongoing':
      return 'blue';
    case 'OK':
    case 'done':
    case 'success':
      return 'green';
    case 'error':
      return 'red';
    default:
      return 'darkGray';
  }
};

export const StatusChipCount: React.FC<{
  status: string;
}> = ({ status, children }) => {
  const c = useMemo(() => getStatus(status), [status]);

  return (
    <ColoredChipLight variant="rounded" size="small" color={c}>
      {children}
    </ColoredChipLight>
  );
};
